module.exports = __webpack_public_path__ + "assets/wix.10ca94b5.svg";